export default __webpack_public_path__ + "static/principle-integrated-light-43f6ab2ddbf1c266bb2ee182cff51e6f.png";